export default "__VITE_ASSET__BBo7oEs3__"